var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container edi-orders-page" },
    [
      _c("div", { staticClass: "statistics-container" }, [
        _c("div", { staticClass: "statistic-card card-danger" }, [
          _c(
            "div",
            {
              staticClass: "statistic-value",
              staticStyle: { color: "#f56c6c" },
            },
            [_vm._v(_vm._s(_vm.topData.exceptionCount || 0))]
          ),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.summaryException"))),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-primary" }, [
          _c("div", { staticClass: "statistic-value" }, [
            _vm._v(_vm._s(_vm.topData.customerActionCount || 0)),
          ]),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(
              _vm._s(_vm.$t("ExternalOrders.EDI.summaryAwaitingClientApproval"))
            ),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-success" }, [
          _c("div", { staticClass: "statistic-value" }, [
            _vm._v(_vm._s(_vm.topData.inProgressCount || 0)),
          ]),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.summaryInProgress"))),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-gray" }, [
          _c("div", { staticClass: "statistic-value" }, [
            _vm._v(_vm._s(_vm.topData.completedCount || 0)),
          ]),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.summaryComplete"))),
          ]),
        ]),
      ]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          serial: false,
          selection: false,
          "auto-fetch": false,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          afterFetchOriginalData: _vm.afterFetchOriginalData,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ExternalOrders.EDI.filterOrderNo"),
                          prop: "orderNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ExternalOrders.EDI.filterOrderNo"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.onView.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orderNo", $$v)
                            },
                            expression: "queryParams.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ExternalOrders.EDI.filterStore"),
                          prop: "code",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ExternalOrders.EDI.filterStore"
                            ),
                            "option-list": _vm.storeList,
                            clearable: false,
                          },
                          on: { change: _vm.handleStoreChange },
                          model: {
                            value: _vm.queryParams.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "code", $$v)
                            },
                            expression: "queryParams.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ExternalOrders.EDI.filterRetailer"),
                          prop: "retailer",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ExternalOrders.EDI.filterRetailer"
                            ),
                            "option-list": _vm.retailerList,
                          },
                          model: {
                            value: _vm.queryParams.retailer,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "retailer", $$v)
                            },
                            expression: "queryParams.retailer",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ExternalOrders.EDI.filterEdiStatus"),
                          prop: "filter",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ExternalOrders.EDI.filterEdiStatus"
                            ),
                            "option-list": _vm.filterList,
                          },
                          model: {
                            value: _vm.queryParams.filter,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "filter", $$v)
                            },
                            expression: "queryParams.filter",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ExternalOrders.EDI.filterActionOwner"),
                          prop: "actionOwner",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ExternalOrders.EDI.filterActionOwner"
                            ),
                            "option-list": _vm.actionOwnerList,
                          },
                          model: {
                            value: _vm.queryParams.actionOwner,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "actionOwner", $$v)
                            },
                            expression: "queryParams.actionOwner",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop == "orderNo"
                                      ? [_vm._v(_vm._s(scope.row.orderNo))]
                                      : col.prop == "statusLabel"
                                      ? [
                                          scope.row.statusLabel === "exception"
                                            ? _c(
                                                "el-tooltip",
                                                {
                                                  attrs: {
                                                    content:
                                                      scope.row.statusDesc ||
                                                      _vm.$t(
                                                        _vm.filterList.bjGet(
                                                          scope.row.statusLabel
                                                        )
                                                      ),
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "edi-status-exception",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.filterList.bjGet(
                                                              scope.row
                                                                .statusLabel
                                                            )
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.filterList.bjGet(
                                                        scope.row.statusLabel
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: {
                                          disabled:
                                            props.row.statusLabel !=
                                            "exception",
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRetry(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ExternalOrders.page.retryBtn"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: {
                                          disabled: !props.row.isShowApproveBtn,
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onApprove(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("billingPage.DEPAppro"))
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("EdiDetailDrawer", {
        ref: "EdiDetailDrawer",
        on: { refresh: _vm.reFresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }